import Vue from 'vue'
import Router from 'vue-router'
// import Index from '@/index/index.vue'
import Articles from '@/hc/articles.vue'
import Categories from '@/hc/categories.vue'
// import Sections from '@/hc/sections.vue'
import Search from '@/hc/search.vue'

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [{
            path: '/',
            name: 'index',
            component: Categories,
            meta: {
                title: '首页'
            },
            children: [{
                path: '/hc/categories/:id',
                name: 'categories',
                component: Categories,
                meta: {
                    title: '类型'
                }
            }]
        }, {
            path: '/hc/articles/:id',
            name: 'hc_articles',
            component: Articles,
            meta: {
                title: '详情'
            }
        },
        {
            path: '/detail/:id',
            name: 'articles',
            component: Articles,
            meta: {
                title: '详情'
            }
        }, {
            path: '/hc/search',
            name: 'search',
            component: Search,
            meta: {
                title: '搜索列表'
            }

        }, {
            path: '*',
            name: 'Error',
            component: Error,
        }

    ]
})
const originalPush = Router.prototype.push
    //修改原型对象中的push方法
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}


// WEBPACK FOOTER //
// ./src/router/index.js